import axios, { type AxiosResponse } from "axios";
import { adminApiUrl, signedInApiUrl } from "../util/Constants";
import type { StickyNote } from "../types/domain";

const BOARD_API = "/board";

export interface CreateStickyNotePayload {
  imageData: string;
  x: number;
  y: number;
  rotation: number;
  paperColor: string;
  pinColor: string;
  poll: boolean;
}

export const boardApi = {
  getNotes: async (): Promise<StickyNote[]> => {
    const { data } = await axios.get<StickyNote[]>(`${signedInApiUrl}${BOARD_API}/notes`);
    return data;
  },

  createNote: async (payload: CreateStickyNotePayload): Promise<StickyNote> => {
    const { data } = await axios.post<StickyNote>(`${signedInApiUrl}${BOARD_API}/notes`, payload);
    return data;
  },

  moveNote: async (id: number, x: number, y: number, rotation?: number): Promise<StickyNote> => {
    const { data } = await axios.patch<StickyNote>(
      `${signedInApiUrl}${BOARD_API}/notes/${id}/position`,
      { x, y, rotation: rotation ?? null },
    );
    return data;
  },

  vote: async (id: number, vote: "YES" | "NO"): Promise<StickyNote> => {
    const { data } = await axios.post<StickyNote>(`${signedInApiUrl}${BOARD_API}/notes/${id}/vote`, { vote });
    return data;
  },

  removeVote: async (id: number): Promise<StickyNote> => {
    const { data } = await axios.delete<StickyNote>(`${signedInApiUrl}${BOARD_API}/notes/${id}/vote`);
    return data;
  },

  deleteOwn: async (id: number): Promise<AxiosResponse> => {
    return axios.delete(`${signedInApiUrl}${BOARD_API}/notes/${id}`);
  },

  deleteAsAdmin: async (id: number): Promise<AxiosResponse> => {
    return axios.delete(`${adminApiUrl}${BOARD_API}/notes/${id}`);
  },
};
